import { render, staticRenderFns } from "./integration.vue?vue&type=template&id=18f4d3c4&"
import script from "./integration.vue?vue&type=script&lang=js&"
export * from "./integration.vue?vue&type=script&lang=js&"
import style0 from "./integration.vue?vue&type=style&index=0&id=18f4d3c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports